/** পেজ-বিল্ডারের নতুন সেকশনগুলোর লেখা (ST-10)। */
export const shopSections = {
    slides: "হাইলাইট",
    dealEnds: "শেষ হবে",
    shopNow: "এখনই কিনুন",
    lookbook: "লুকটি কিনুন",
    viewProduct: "{{name}} দেখুন",
    logos: "যেখানে আমাদের দেখেছেন",
    bundle: "একসাথে কিনুন",
    bundleTotal: "{{n}}টির মোট",
    bundleOut: "এর মধ্যে একটি এখন স্টকে নেই।",
    playVideo: "ভিডিও চালান: {{title}}",
    video: "ভিডিও",
    yes: "হ্যাঁ",
    no: "না",
    feature: "বৈশিষ্ট্য",
    step: "ধাপ {{n}}",
    recentlyViewed: "সম্প্রতি দেখেছেন",
    menuAdd: "দেখুন",
    // ST-11 (A7–A9)
    storeLocator: "আমাদের দোকানে আসুন",
    hours: "খোলার সময়",
    call: "কল করুন {{phone}}",
    directions: "পথ দেখুন",
    orderAgain: "আবার অর্ডার করুন",
    orderAgainIntro: "আপনার সাম্প্রতিক অর্ডার থেকে, আজকের দামে।",
    orderAgainAll: "সব কার্টে যোগ করুন",
    orderAgainAdding: "যোগ হচ্ছে…",
    orderAgainAdded: "{{n}}টি পণ্য কার্টে যোগ হয়েছে।",
    orderAgainSkipped: "{{n}}টি স্টকে নেই, যোগ হয়নি।",
    orderAgainFailed: "যোগ করা যায়নি। আবার চেষ্টা করুন।",
    orderAgainQty: "{{qty}} × {{price}}",
    outOfStock: "স্টকে নেই",
    fewLeft: "অল্প বাকি",
    sold: "গত ৩০ দিনে {{n}}+ বিক্রি",
    soldShort: "{{n}}+ বিক্রি",
    ourShops: "আমাদের দোকান",
    productCount_one: "{{n}}টি পণ্য",
    productCount_other: "{{n}}টি পণ্য",
};
//# sourceMappingURL=shop-sections.js.map